import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  getIsSixteenBitCanOutput,
  getHasNativeOutput,
  getHasBooleanNativeOutput,
  getHasNonBooleanNativeOutput,
} from 'selectors/feature/outputs'
import { setConditionField } from 'actions/feature/conditions'
import CanInputEditor from './CanInputEditor'

const makeMapStateToProps = () => (state, ownProps) => {
  const { fnId } = ownProps
  const hasSixteenBitOutput = getIsSixteenBitCanOutput(state, {
    id: fnId,
  })
  const isOutputBoolean = getHasBooleanNativeOutput(state, {
    id: fnId,
  })
  const hasNativeOutput = getHasNativeOutput(state, { id: fnId })
  const hasNonBooleanNativeOutput = getHasNonBooleanNativeOutput(state, {
    id: fnId,
  })
  return {
    hasSixteenBitOutput,
    hasNativeOutput,
    isOutputBoolean,
    hasNonBooleanNativeOutput,
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { uri } = ownProps
  return {
    ...bindActionCreators(
      {
        onNumberOfBitsChange: (event) =>
          setConditionField(uri, 'numberOfBits', event.target.value),
        onStartBitChange: (startBit) =>
          setConditionField(uri, 'startBit', startBit),
      },
      dispatch
    ),
  }
}

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  const { uri, numberOfBits, startBit, canId } = ownProps
  const { onNumberOfBitsChange, onStartBitChange } = propsFromDispatch
  const {
    hasSixteenBitOutput,
    hasNativeOutput,
    isOutputBoolean,
    hasNonBooleanNativeOutput,
  } = propsFromState

  return {
    ...ownProps,
    uri,
    onNumberOfBitsChange,
    onStartBitChange: numberOfBits ? onStartBitChange : () => {},
    numberOfBits,
    startBit,
    canId,
    hasSixteenBitOutput,
    hasNativeOutput,
    isOutputBoolean,
    hasNonBooleanNativeOutput,
  }
}

const connected = connect(
  makeMapStateToProps,
  mapDispatchToProps,
  mergeProps
)(CanInputEditor)

export default connected
